// @ts-nocheck
// src/components/PendingCheckinsAdminCard.tsx
// ---------------------------------------------------------------------------
// v6.478 — ΚΑΡΤΑ ADMIN: ΟΛΑ τα εκκρεμή check-in / check-out, ΜΑΖΙ με τα παλιά
// (ναύλοι που έχουν ήδη τελειώσει). Τα παλιά ΔΕΝ μπαίνουν στην κόκκινη μπάρα
// του υπαλλήλου — μόνο εδώ.
//
// Πηγή: api/pending-checkins.php?scope=admin (ο SERVER κρίνει τι είναι εκκρεμές).
// ---------------------------------------------------------------------------

import React, { useState, useEffect, useCallback } from 'react';

const API_BASE = 'https://yachtmanagementsuite.com/api';

function ageText(minutes) {
  if (minutes == null) return '—';
  if (minutes < 90) return `${minutes} λεπτά`;
  if (minutes < 60 * 48) return `${Math.round(minutes / 60)} ώρες`;
  return `${Math.round(minutes / (60 * 24))} μέρες`;
}

export default function PendingCheckinsAdminCard() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await fetch(`${API_BASE}/pending-checkins.php?scope=admin&t=${Date.now()}`);
      if (!r.ok) return;
      const d = await r.json();
      if (d && d.success && Array.isArray(d.pending)) { setItems(d.pending); setLoaded(true); }
    } catch (e) {
      console.warn('PendingCheckinsAdminCard: fetch failed:', e);
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 2 * 60 * 1000);
    return () => clearInterval(id);
  }, [load]);

  if (!loaded || items.length === 0) return null;

  const live = items.filter((p) => !p.charterEnded);
  const old  = items.filter((p) => p.charterEnded);

  const Row = ({ p }) => (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
      padding: '8px 10px', borderBottom: '1px solid #f1f5f9', fontSize: 13,
    }}>
      <div style={{ flex: '1 1 260px', minWidth: 0 }}>
        <strong>{p.bookingNumber}</strong>
        <span style={{
          marginLeft: 8, fontSize: 11, fontWeight: 700, padding: '1px 6px', borderRadius: 6,
          background: p.mode === 'in' ? '#dbeafe' : '#fce7f3',
          color: p.mode === 'in' ? '#1e40af' : '#9d174d',
        }}>
          {p.mode === 'in' ? 'Check-in' : 'Check-out'}
        </span>
        <div style={{ color: '#475569', fontSize: 12, marginTop: 2 }}>
          ⛵ {p.vesselName || '—'}
          {p.checkInDate ? ` · ${p.checkInDate}` : ''}{p.checkOutDate ? ` → ${p.checkOutDate}` : ''}
          {' · '}στάσιμο {ageText(p.ageMinutes)}
        </div>
      </div>
      <div style={{
        fontWeight: 800, fontSize: 13,
        color: p.missingItems > 0 ? '#b91c1c' : '#15803d', whiteSpace: 'nowrap',
      }}>
        {p.doneItems}/{p.totalItems}
        <span style={{ fontWeight: 500, color: '#64748b' }}> · σελ. {p.resumePage}</span>
      </div>
    </div>
  );

  return (
    <div style={{
      marginBottom: 12, background: '#fff', borderRadius: 12,
      border: '2px solid #dc2626', overflow: 'hidden',
      boxShadow: '0 4px 14px rgba(220,38,38,0.15)',
    }}>
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          width: '100%', textAlign: 'left', border: 'none', cursor: 'pointer',
          background: '#dc2626', color: '#fff', padding: '10px 14px',
          fontWeight: 800, fontSize: 14, display: 'flex',
          alignItems: 'center', justifyContent: 'space-between', gap: 10,
        }}
      >
        <span>⚠️ Εκκρεμή Check-in / Check-out: {items.length}</span>
        <span style={{ fontWeight: 600, fontSize: 12 }}>
          {live.length} ενεργά · {old.length} παλιά {open ? '▲' : '▼'}
        </span>
      </button>

      {open && (
        <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
          {live.length > 0 && (
            <>
              <div style={{ padding: '6px 10px', background: '#fef2f2', fontWeight: 700, fontSize: 12, color: '#991b1b' }}>
                ΕΝΕΡΓΟΙ ΝΑΥΛΟΙ — φαίνονται και στη μπάρα του υπαλλήλου
              </div>
              {live.map((p) => <Row key={`${p.bookingNumber}|${p.mode}`} p={p} />)}
            </>
          )}
          {old.length > 0 && (
            <>
              <div style={{ padding: '6px 10px', background: '#f8fafc', fontWeight: 700, fontSize: 12, color: '#475569' }}>
                ΠΑΛΙΑ (ναύλοι που τελείωσαν) — ΜΟΝΟ εδώ, όχι στη μπάρα
              </div>
              {old.map((p) => <Row key={`${p.bookingNumber}|${p.mode}`} p={p} />)}
            </>
          )}
        </div>
      )}
    </div>
  );
}
